export const hiddenModules = ["customer-health", "difot-report"];

export const isModuleHidden = (moduleKey) => !!moduleKey && hiddenModules.includes(moduleKey);
